const videojsSetup = {
  videoJsPlayer: {
    playerType: 'standard', // embed or standard
    startFrame: 0,
    frameList: [
      { frame: -75, char: '&llarr;' },
      { frame: -10, char: '&larr;' },
      { frame: -5, char: '-5' },
      { frame: -1, char: '-1' },
      { frame: 1, char: '1' },
      { frame: 5, char: '5' },
      { frame: 10, char: '&rarr;' },
      { frame: 75, char: '&rrarr;' }
    ],
    autoplay: false,
    muted: false,
    volume: 0.5, //  after user reset it will be stored in localstorage
    showTimeCode: true,
    showFrameCode: false,
    showAudioMonitor:true,
    enableAudioMonitor:true,
    showTitleSafe: false,
    sideNav: {
      program: true,
      tvShowProgram: true,
      playList: true,
      snapshot: true,
      lightTable: true,
      comment: true,
      help: true
    },
    mainVideo: {
      program: [
        {
          id: 'playlistButtonTitle',
          label: 'Aron cím',
          data: `Main videó`,
          show: true
        },
        {
          id: 'playlistButtonSecondaryTitle',
          label: 'Aron cím 2',
          data: `main vid másodlagos cím`,
          show: true
        },
        {
          id: 'url',
          label: 'Video url címe',
          data: 'video/sample.mp4', // CHANGE VIDEO SRC TO SOME LOCAL VIS FOR TESTING
          show: true
        },
        {
          id: 'mainVideo',
          label: 'Ez a videó címe',
          data: `main ${Math.floor(Math.random() * 100000 + 1)}`,
          show: true
        },
        {
          id: 'duration',
          label: 'Ez a képkockaszám',
          data: 38943,
          show: false
        }
      ],
      tvShowProgram: [
        {
          id: 'durationTc',
          label: 'Ez egy minta sor',
          data: `Minta adat`,
          show: true
        }
      ],

      linkButtons: [
        { url: 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4', label: 'Link másolás', type: '', download: '', target: '_blank', isCopy: true },
        { url: 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_640_3MG.mp4', label: 'Link letöltés', type: 'video/mp4', download: 'rendesnevu.mp4', target: '', isCopy: false }
      ],
      preview: {
        isPreRenderedThumbSet: true,
        preRenderedThumbUrl: 'img/sprite/minta.jpg',
        preRenderedThumbInterval: 1.84,
        preRenderedThumbWidth: 160,
        preRenderedThumbHeight: 90
      },
      textTracks: [
        { kind: 'captions', label: 'magyar', mode: 'hidden', language: 'hu', id: 1, src: 'texttrack/film1_hu.vtt' },
        { kind: 'captions', label: 'angol', mode: 'hidden', language: 'en', id: 2, src: 'texttrack/film1_en.vtt' }
      ],
      proxyData: {
        sessionID: 148212,
        clipGuid: '0F69D00B-0928-4EEF-BEF7-972A2EE517F6',
        storagePath: '/mnt/isilon/proxy/proxy/ADAS/1984/00005/1984M00005-00010-20.mp4',
        catalogID: 2381438,
        recordID: 3504109
      }
    },
    playList: [
      {
        program: [
          {
            id: 'playlistButtonTitle',
            label: 'Aron cím',
            data: `playlist element teszt`,
            show: true
          },
          {
            id: 'playlistButtonSecondaryTitle',
            label: 'Aron második cím',
            data: `Ez egy másodlagos cím`,
            show: true
          },
          {
            id: 'durationTc',
            label: 'Playlist element adat 2',
            data: `durationTc ${Math.floor(Math.random() * 100000 + 1)}`,
            show: true
          },
          {
            id: 'url',
            label: 'Webcím',
            data: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
            show: true
          }
        ],
        tvShowProgram: [
          {
            id: 'programId',
            label: 'Másik videó adatai',
            data: `programId ${Math.floor(Math.random() * 100000 + 1)}`,
            show: true
          }
        ],
        endpoint: {
          review: 'https://taumam.mtva.hu/tau/api/legacy/review.php?getReviewHistory&recordID=2762559&_=1607420361069',
          record: 'https://taumam.mtva.hu/tau/api/legacy/simplesearch.php?proxyCatalogID='
        },
        linkButtons: [
          { url: 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MGssssssssssssss.mp4', label: 'Link másolás', type: '', download: '', target: '_blank', isCopy: true },
          { url: 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_640_3MG.mp4', label: 'Link letöltés', type: 'video/mp4', download: 'rendesnevu.mp4', target: '', isCopy: false }
        ],
        preview: {
          preRenderedThumbUrl: 'img/sprite/frame1.jpg',
          preRenderedThumbInterval: 0.68,
          isPreRenderedThumbSet: true,
          preRenderedThumbWidth: 300,
          preRenderedThumbHeight: 90
        },
        textTracks: [
          { kind: 'captions', label: '1magyar', mode: 'hidden', language: 'hu', id: 3, src: 'texttrack/film1_hu.vtt' },
          { kind: 'captions', label: '1angol', mode: 'hidden', language: 'en', id: 4, src: 'texttrack/film1_en.vtt' }
        ],
        proxyData: {
          sessionID: 148213,
          clipGuid: '0F69D00B-0928-4EEF-BEF7-972A2EE517F7',
          storagePath: '/mnt/isilon/proxy/proxy/ADAS/1984/00005/1984M00005-00010-21.mp4',
          catalogID: 2381439,
          recordID: 300996
        }
      }
    ],
    endPoint: {
      getReviewUrl: 'https://tautest/taudev4/api/v1/review/getReviewHistory/?recordID=',
      postReviewUrl: 'https://tautest/taudev4/api/v1/review/setReview'
    },
    snapshotDesignBg: [
      { name: 'Fekete', safeName: 'fekete' },
      { name: 'MTVA', safeName: 'mtva' },
      { name: 'Áttetsző', safeName: 'attetszo' }
    ],
    outputRes: [
      {
        name: 'Telekom',
        data: [
          {
            label: '1920x1080',
            opt: false,
            width: 1920,
            height: 1080,
            bg: './img/m1/2016_mtva_lila_remake_1920x1080px.jpg'
          },
          {
            label: '1280x720',
            opt: false,
            width: 1280,
            height: 720,
            bg: './img/m1/2016_mtva_lila_remake_1500x1500px.jpg'
          },
          {
            label: '450x675',
            opt: true,
            width: 450,
            height: 675,
            bg: './img/m1/2016_mtva_lila_remake_1000x1000px.jpg'
          },
          {
            label: '560x820',
            opt: false,
            width: 560,
            height: 820,
            bg: './img/m1/2016_mtva_lila_remake_1000x1000px.jpg'
          }
        ]
      },
      {
        name: 'Antenna',
        data: [
          {
            label: '950x713',
            opt: true,
            width: 950,
            height: 713,
            bg: './img/m1/2016_mtva_lila_remake_1000x1000px.jpg'
          }
        ]
      },
      {
        name: 'Upc',
        data: [
          {
            label: '180x260',
            opt: true,
            width: 180,
            height: 260,
            bg: './img/m1/2016_mtva_lila_remake_300x300px.jpg'
          },
          {
            label: '96x128',
            opt: false,
            width: 96,
            height: 128,
            bg: './img/m1/2016_mtva_lila_remake_200x200px.jpg'
          }
        ]
      },
      {
        name: 'Invitel',
        data: [
          {
            label: '160x210',
            opt: true,
            width: 160,
            height: 210,
            bg: './img/m1/2016_mtva_lila_remake_200x200px.jpg'
          }
        ]
      },
      {
        name: 'Standard',
        data: [
          {
            label: 'hd_1920x1080',
            opt: false,
            width: 1920,
            height: 1080,
            bg: './img/m1/2016_mtva_lila_remake_1920x1080px.jpg'
          },
          {
            label: 'hdv_1280x720',
            opt: true,
            width: 1280,
            height: 720,
            bg: './img/m1/2016_mtva_lila_remake_1500x1500px.jpg'
          },
          {
            label: 'pal_720x576',
            opt: true,
            width: 720,
            height: 576,
            bg: './img/m1/2016_mtva_lila_remake_1000x1000px.jpg'
          }
        ]
      }
    ]
  }
};
export default videojsSetup;
